"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const __1 = require("../..");
const SearchContext_1 = __importDefault(require("../../contexts/SearchContext"));
const Suspense_1 = __importDefault(require("../Http/Suspense"));
const SearchResults = (props) => {
    const { children } = props;
    const { searchHits, searchHitPaginator } = react_1.useContext(SearchContext_1.default);
    // we expect children to be a function we can pass searchHits to
    return (react_1.default.createElement(Suspense_1.default, Object.assign({ hook: searchHitPaginator }, props), children(searchHits)));
};
exports.default = __1.withJourney('j-search-results', SearchResults);
